import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "default4": "products-33612c4d-default4-WXUgJq",
  "wideOffset0": "products-33612c4d-wideOffset0-WXUgJq",
  "default6": "products-33612c4d-default6-WXUgJq",
  "xwideOffset7": "products-33612c4d-xwideOffset7-WXUgJq",
  "wide6": "products-33612c4d-wide6-WXUgJq",
  "default7": "products-33612c4d-default7-WXUgJq",
  "tinyOffset0": "products-33612c4d-tinyOffset0-WXUgJq",
  "tiny10": "products-33612c4d-tiny10-WXUgJq",
  "tinyOffset4": "products-33612c4d-tinyOffset4-WXUgJq",
  "confined4": "products-33612c4d-confined4-WXUgJq",
  "tinyOffset5": "products-33612c4d-tinyOffset5-WXUgJq",
  "confinedOffset0": "products-33612c4d-confinedOffset0-WXUgJq",
  "xwide1": "products-33612c4d-xwide1-WXUgJq",
  "gridContainer": "products-33612c4d-gridContainer-WXUgJq",
  "confined2": "products-33612c4d-confined2-WXUgJq",
  "confined11": "products-33612c4d-confined11-WXUgJq",
  "tiny1": "products-33612c4d-tiny1-WXUgJq",
  "xwide10": "products-33612c4d-xwide10-WXUgJq",
  "confined1": "products-33612c4d-confined1-WXUgJq",
  "default0": "products-33612c4d-default0-WXUgJq",
  "col": "products-33612c4d-col-WXUgJq",
  "tiny6": "products-33612c4d-tiny6-WXUgJq",
  "xwide0": "products-33612c4d-xwide0-WXUgJq",
  "default10": "products-33612c4d-default10-WXUgJq",
  "tiny8": "products-33612c4d-tiny8-WXUgJq",
  "default9": "products-33612c4d-default9-WXUgJq",
  "wide2": "products-33612c4d-wide2-WXUgJq",
  "xwideOffset6": "products-33612c4d-xwideOffset6-WXUgJq",
  "defaultOffset2": "products-33612c4d-defaultOffset2-WXUgJq",
  "wide3": "products-33612c4d-wide3-WXUgJq",
  "confinedOffset2": "products-33612c4d-confinedOffset2-WXUgJq",
  "confined8": "products-33612c4d-confined8-WXUgJq",
  "confinedOffset10": "products-33612c4d-confinedOffset10-WXUgJq",
  "confinedOffset3": "products-33612c4d-confinedOffset3-WXUgJq",
  "tiny12": "products-33612c4d-tiny12-WXUgJq",
  "default3": "products-33612c4d-default3-WXUgJq",
  "xwide6": "products-33612c4d-xwide6-WXUgJq",
  "xwide12": "products-33612c4d-xwide12-WXUgJq",
  "xwide3": "products-33612c4d-xwide3-WXUgJq",
  "xwide4": "products-33612c4d-xwide4-WXUgJq",
  "defaultOffset8": "products-33612c4d-defaultOffset8-WXUgJq",
  "tinyOffset1": "products-33612c4d-tinyOffset1-WXUgJq",
  "default8": "products-33612c4d-default8-WXUgJq",
  "confined6": "products-33612c4d-confined6-WXUgJq",
  "wide10": "products-33612c4d-wide10-WXUgJq",
  "tinyOffset6": "products-33612c4d-tinyOffset6-WXUgJq",
  "wide12": "products-33612c4d-wide12-WXUgJq",
  "grid": "products-33612c4d-grid-WXUgJq",
  "wideOffset9": "products-33612c4d-wideOffset9-WXUgJq",
  "xwide2": "products-33612c4d-xwide2-WXUgJq",
  "wide11": "products-33612c4d-wide11-WXUgJq",
  "armstrongGridContainer": "products-33612c4d-armstrongGridContainer-WXUgJq",
  "confined12": "products-33612c4d-confined12-WXUgJq",
  "wideOffset8": "products-33612c4d-wideOffset8-WXUgJq",
  "xwideOffset10": "products-33612c4d-xwideOffset10-WXUgJq",
  "tiny7": "products-33612c4d-tiny7-WXUgJq",
  "xwideOffset9": "products-33612c4d-xwideOffset9-WXUgJq",
  "tinyOffset7": "products-33612c4d-tinyOffset7-WXUgJq",
  "defaultOffset9": "products-33612c4d-defaultOffset9-WXUgJq",
  "tinyOffset10": "products-33612c4d-tinyOffset10-WXUgJq",
  "tinyOffset3": "products-33612c4d-tinyOffset3-WXUgJq",
  "confinedOffset7": "products-33612c4d-confinedOffset7-WXUgJq",
  "wideOffset3": "products-33612c4d-wideOffset3-WXUgJq",
  "wideOffset11": "products-33612c4d-wideOffset11-WXUgJq",
  "defaultOffset3": "products-33612c4d-defaultOffset3-WXUgJq",
  "default11": "products-33612c4d-default11-WXUgJq",
  "xwideOffset4": "products-33612c4d-xwideOffset4-WXUgJq",
  "tiny3": "products-33612c4d-tiny3-WXUgJq",
  "tiny0": "products-33612c4d-tiny0-WXUgJq",
  "tiny11": "products-33612c4d-tiny11-WXUgJq",
  "defaultOffset1": "products-33612c4d-defaultOffset1-WXUgJq",
  "defaultOffset7": "products-33612c4d-defaultOffset7-WXUgJq",
  "tiny2": "products-33612c4d-tiny2-WXUgJq",
  "wide5": "products-33612c4d-wide5-WXUgJq",
  "wideOffset4": "products-33612c4d-wideOffset4-WXUgJq",
  "tiny5": "products-33612c4d-tiny5-WXUgJq",
  "xwide11": "products-33612c4d-xwide11-WXUgJq",
  "confinedOffset1": "products-33612c4d-confinedOffset1-WXUgJq",
  "confinedOffset11": "products-33612c4d-confinedOffset11-WXUgJq",
  "wideGridContainer": "products-33612c4d-wideGridContainer-WXUgJq",
  "defaultOffset5": "products-33612c4d-defaultOffset5-WXUgJq",
  "default5": "products-33612c4d-default5-WXUgJq",
  "confined10": "products-33612c4d-confined10-WXUgJq",
  "xwideOffset3": "products-33612c4d-xwideOffset3-WXUgJq",
  "wide4": "products-33612c4d-wide4-WXUgJq",
  "tinyOffset2": "products-33612c4d-tinyOffset2-WXUgJq",
  "xwideOffset11": "products-33612c4d-xwideOffset11-WXUgJq",
  "wideOffset5": "products-33612c4d-wideOffset5-WXUgJq",
  "defaultOffset10": "products-33612c4d-defaultOffset10-WXUgJq",
  "defaultOffset6": "products-33612c4d-defaultOffset6-WXUgJq",
  "wideOffset7": "products-33612c4d-wideOffset7-WXUgJq",
  "defaultOffset11": "products-33612c4d-defaultOffset11-WXUgJq",
  "confinedOffset6": "products-33612c4d-confinedOffset6-WXUgJq",
  "confined3": "products-33612c4d-confined3-WXUgJq",
  "wide7": "products-33612c4d-wide7-WXUgJq",
  "xwideOffset2": "products-33612c4d-xwideOffset2-WXUgJq",
  "xwideOffset5": "products-33612c4d-xwideOffset5-WXUgJq",
  "xwideOffset0": "products-33612c4d-xwideOffset0-WXUgJq",
  "xwide5": "products-33612c4d-xwide5-WXUgJq",
  "default1": "products-33612c4d-default1-WXUgJq",
  "tinyOffset8": "products-33612c4d-tinyOffset8-WXUgJq",
  "wide8": "products-33612c4d-wide8-WXUgJq",
  "defaultOffset4": "products-33612c4d-defaultOffset4-WXUgJq",
  "tinyOffset9": "products-33612c4d-tinyOffset9-WXUgJq",
  "wide9": "products-33612c4d-wide9-WXUgJq",
  "xwideOffset1": "products-33612c4d-xwideOffset1-WXUgJq",
  "confinedOffset9": "products-33612c4d-confinedOffset9-WXUgJq",
  "confinedOffset5": "products-33612c4d-confinedOffset5-WXUgJq",
  "default2": "products-33612c4d-default2-WXUgJq",
  "standardGridContainer": "products-33612c4d-standardGridContainer-WXUgJq",
  "wide1": "products-33612c4d-wide1-WXUgJq",
  "xwide8": "products-33612c4d-xwide8-WXUgJq",
  "tiny4": "products-33612c4d-tiny4-WXUgJq",
  "tinyOffset11": "products-33612c4d-tinyOffset11-WXUgJq",
  "confined0": "products-33612c4d-confined0-WXUgJq",
  "wideOffset6": "products-33612c4d-wideOffset6-WXUgJq",
  "xwide9": "products-33612c4d-xwide9-WXUgJq",
  "confined7": "products-33612c4d-confined7-WXUgJq",
  "confinedOffset4": "products-33612c4d-confinedOffset4-WXUgJq",
  "wide0": "products-33612c4d-wide0-WXUgJq",
  "default12": "products-33612c4d-default12-WXUgJq",
  "confined9": "products-33612c4d-confined9-WXUgJq",
  "xwideOffset8": "products-33612c4d-xwideOffset8-WXUgJq",
  "wideOffset1": "products-33612c4d-wideOffset1-WXUgJq",
  "xwide7": "products-33612c4d-xwide7-WXUgJq",
  "confined5": "products-33612c4d-confined5-WXUgJq",
  "tiny9": "products-33612c4d-tiny9-WXUgJq",
  "wideOffset2": "products-33612c4d-wideOffset2-WXUgJq",
  "wideOffset10": "products-33612c4d-wideOffset10-WXUgJq",
  "row": "products-33612c4d-row-WXUgJq",
  "confinedOffset8": "products-33612c4d-confinedOffset8-WXUgJq"
};